/**
 * `<AiDisclosureSection>` — the fixed AI-use disclosure that closes every
 * AI-assisted note (PD-1613). Render-only: `aiAssisted` is set by the AI paths
 * and kept true by the server; nothing here edits it.
 */
import { Box, Text } from '@mantine/core'
import { useFormContext, useWatch } from 'react-hook-form'
import type { ProgressNoteEditFormValues } from '../progressNoteEditSchema'
import { encounterLanguageDisclosure } from '@behuman/core-contract'
import { AI_DISCLOSURE_HEADING, AI_DISCLOSURE_TEXT } from '@/model/middleware-types'
import { NoteHeading } from './NoteHeading'

export function AiDisclosureSection() {
  const { control } = useFormContext<ProgressNoteEditFormValues>()
  const aiAssisted = useWatch({ control, name: 'aiAssisted' })
  const encounterLanguage = useWatch({ control, name: 'encounterLanguage' })

  if (!aiAssisted) return null
  // PD-1600 — a non-English encounter says so first, inside the same disclosure.
  const languageSentence = encounterLanguageDisclosure(encounterLanguage)

  return (
    <Box mb="xl" data-testid="ai-disclosure">
      <NoteHeading level="section" id="ai-disclosure" label={AI_DISCLOSURE_HEADING} />
      <Box
        style={{
          background: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: 8,
          padding: '10px 14px',
        }}
      >
        <Text size="sm" c="dark.7" style={{ lineHeight: 1.7 }}>
          {languageSentence ? `${languageSentence} ${AI_DISCLOSURE_TEXT}` : AI_DISCLOSURE_TEXT}
        </Text>
      </Box>
    </Box>
  )
}
